export default __webpack_public_path__ + "static/media/none.d7eb3473.svg";